import { CheckoutNormalizer } from "./CheckoutFormats/CheckoutNormalizer";

// Derives the billing type shapes the UI consumes from a raw checkout payload.
// Shared by the initial load and by the discounted payload returned on member
// validation, so both go through the exact same derivation.
export const normalizeCheckout = checkoutData => {
  const version = checkoutData?.checkout_payment_types_available?.length
    ? "v2"
    : "v1";
  const formatter = CheckoutNormalizer(version);

  return {
    ...checkoutData,
    product_name: checkoutData?.product?.name || checkoutData?.name,
    billing_types_options: formatter.getBillingTypesOptions(checkoutData),
    billing_types: formatter.billingTypesPerKey(checkoutData),
    max_installment_billing_type:
      formatter.getMaxPossibleInstallment(checkoutData),
    cheapest_installment_billing_type:
      formatter.getCheapestInstallment(checkoutData),
  };
};
